'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "method", "url", "data"];
import { MessageTypes } from '../Constants';
const isRequestAllowed = (method, url, whitelist) => {
  const len = whitelist.length;
  for (let i = 0; i < len; i++) {
    const rule = whitelist[i];
    const {
      regex,
      methods
    } = rule;
    if (methods.includes(method) && regex.test(url)) {
      return true;
    }
  }
  return false;
};

// Matches `../` and `..\` path traversal sequences,
// including URL encoded and double-encoded versions.
const pathTraversalCharsToRemove = /((\.|%2E|%252E){2,}(\/|%2F|%252F|\\|%5C|%255C)+)*/gi;
const sanitizeUrlPath = rawPathname => {
  const shouldStripLeadingSlash = !rawPathname.startsWith('/');
  const parsedUrl = new URL(rawPathname, window.location.origin);
  const pathname = parsedUrl.pathname.replace(pathTraversalCharsToRemove, '');
  return shouldStripLeadingSlash ? pathname.slice(1) : pathname;
};
const methodMap = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};
export const apiResponderMiddleware = (apiClient, whitelist = []) => {
  return (message, postResponse) => {
    let parsedData;
    const {
        type,
        method,
        url: rawUrl,
        data
      } = message,
      body = _objectWithoutPropertiesLoose(message, _excluded);
    if (type !== MessageTypes.API_REQUEST) {
      return message;
    }
    if (typeof data !== 'undefined') {
      try {
        parsedData = JSON.parse(data);
      } catch (e) {
        postResponse(message, e.message, MessageTypes.ERROR);
        return message;
      }
      body.data = parsedData;
    }
    const url = sanitizeUrlPath(rawUrl);
    if (isRequestAllowed(method, url, whitelist)) {
      const requestMethod = methodMap[method];
      if (requestMethod) {
        apiClient[requestMethod](url, body).then(response => {
          postResponse(message, response, MessageTypes.API_RESPONSE);
        }).catch(error => {
          const {
            code,
            data: errorData,
            headers,
            message: errorMessage,
            responseJSON,
            responseText,
            status
          } = error;
          const response = {
            code,
            data: errorData,
            headers,
            message: errorMessage,
            responseJSON,
            responseText,
            status
          };
          postResponse(message, response, MessageTypes.ERROR);
        });
        return null;
      }
    }
    return message;
  };
};